/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect} from 'react'
import {Outlet, Link} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import './index.css'

const AuthLayout = () => {
  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, [])

  return (
    <div className='d-flex flex-column flex-lg-row flex-column-fluid h-100 bg-image'>
      <div className='d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-1 bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed overflow-auto min-h-100'>
        <div className='d-flex justify-content-center align-items-center h-100'>
          <Outlet />
        </div>
      </div>
      <div className='d-flex justify-content-center flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-2 min-h-100'>
        <div className='min-h-100 w-100 col-lg-6 d-flex order-1 order-lg-2'>
          <div className='d-flex flex-column flex-center py-15 px-5 px-md-15 w-100'>
            <img
              alt='Logo'
              src={toAbsoluteUrl('/media/custom-assets/boltsign-logo.png')}
              className='img-fluid mx-auto d-block max-width-md-100 max-width-lg-75 h-md-55px mb-5'
            />

            <h1 className='fw-bolder text-center mb-7 text-primary' style={{fontSize: '18px'}}>
              Smart. Secure. Streamlined Digital Signing Experience
            </h1>
          </div>
        </div>
      </div>
    </div>
  )
}

export {AuthLayout}
